import { AccountContext } from "context/account";
import React, { createContext, useContext, useEffect, useRef, useState } from "react";

import api from "../services/api";

const defaultSharedContentContext = {
  permissionMap: {},
  fullMap: {},
  resourceList: [],
  collaboratorUsers: {},
  retrieveContentPermission: () => {},
  retrieveCollaborators: () => {},
  handleRefresh: () => {},
};

const permissionPrivilegeMap = { 1: "READ", 2: "WRITE" };

const SharedContentContext = createContext(defaultSharedContentContext);
export default SharedContentContext;

export const SharedContentProvider = (props) => {
  const [permissionMap, setPermissionMap] = useState(defaultSharedContentContext.permissionMap);
  const [fullMap, setFullMap] = useState(defaultSharedContentContext.fullMap);

  const [resourceList, setResourceList] = useState(defaultSharedContentContext.resourceList);
  const [collaboratorUsers, setCollaboratorUsers] = useState(
    defaultSharedContentContext.collaboratorUsers
  );

  const account = useContext(AccountContext);

  useEffect(() => {
    if (account.id) {
      handleRefresh();
    }
  }, [account.id]);

  const retrieveContentPermission = async () => {
    try {
      const { data } = await api.resourcePermission.sharedList();
      const resource_permissions = data?.resource_permissions || [];
      let tempMap = {};
      let tempFullMap = {};
      for (let i = 0; i < resource_permissions.length; i++) {
        tempMap[resource_permissions[i]?.resource_id] =
          permissionPrivilegeMap[resource_permissions[i]?.privilege];

        tempFullMap[resource_permissions[i]?.resource_id] = resource_permissions[i];
      }
      setFullMap(tempFullMap);
      setPermissionMap(tempMap);
      setResourceList(resource_permissions);
      return data;
    } catch (err) {
      console.log(err);
    }
  };

  const retrieveCollaborators = async (type) => {
    if (!["product", "collection", "moodboard"].includes(type)) {
      return;
    }
    try {
      let payload = {
        resource_type: type,
      };

      const rp = await api.resourcePermission.retrieveCollaborators(payload);

      let userList = rp?.data?.resource_permissions || [];
      let collaboratorsMap = {};
      for (let i = 0; i < userList.length; i++) {
        if (userList[i]?.resource_id && collaboratorsMap[userList[i]?.resource_id]) {
          collaboratorsMap[userList[i]?.resource_id].push(userList[i]);
        } else {
          collaboratorsMap[userList[i]?.resource_id] = [userList[i]];
        }
      }

      setCollaboratorUsers(collaboratorsMap || {});
    } catch (err) {
      console.log(err);
    }
  };

  const handleRefresh = () => {
    retrieveContentPermission();
    retrieveCollaborators();
  };

  return (
    <SharedContentContext.Provider
      {...props}
      value={{
        ...defaultSharedContentContext,
        permissionMap,
        resourceList,
        collaboratorUsers,
        fullMap,
        retrieveContentPermission,
        retrieveCollaborators,
        handleRefresh,
      }}
    />
  );
};
